import status from '../constants/actionStatus';
import { setActiveQuestionIndex } from "./setActiveQuestionIndex";
import { getQuizzesData } from "../services/quizService";

export const getQuiz = (slug, mode) => {
    return (dispatch) => {
        if (mode) {
            slug = slug + '?mode=' + mode;
        }
        dispatch({
            type: 'GET_QUIZ_REQUEST',
            payload: {
                questions: [],
                totalQuestions: 0,
                id: '',
                status: status.PENDING
            }
        });
        getQuizzesData(slug).then((formattedQuiz) => {
            if (formattedQuiz.duration) {
                // dispatching formattedQuiz data to reducer
                dispatch({
                    type: 'INIT_TIMER',
                    duration: formattedQuiz.duration,
                    timeTaken: formattedQuiz.timeTaken
                });
            }
            dispatch({
                type: 'GET_QUIZ_SUCCESS',
                payload: formattedQuiz
            });
            //set first question as default
            return dispatch(setActiveQuestionIndex(0));

        })
            .catch(function (error) {
                // handle error
                dispatch({
                    type: 'GET_QUIZ_ERROR',
                    payload: {
                        questions: [],
                        totalQuestions: 0,
                        id: '',
                        status: status.ERROR
                    }
                });
            });

    };
};
